import { encodeObject } from '@simonbackx/simple-encoding';
export class IPaginatedResponse {
}
export class UnencodeablePaginatedResponse {
    constructor(data) {
        this.results = data.results;
        this.next = data.next;
    }
}
export class PaginatedResponse {
    constructor(data) {
        this.results = data.results;
        this.next = data.next;
    }
    encode(context) {
        var _a;
        return {
            results: encodeObject(this.results, context), // this.results.map(r => r.encode(context)),
            next: (_a = this.next) === null || _a === void 0 ? void 0 : _a.encode(context),
        };
    }
}
export class PaginatedResponseDecoder {
    constructor(resultDecoder, querydecoder) {
        this.resultDecoder = resultDecoder;
        this.querydecoder = querydecoder;
    }
    decode(data) {
        var _a;
        return new PaginatedResponse({
            results: data.field('results').decode(this.resultDecoder),
            next: (_a = data.optionalField('next')) === null || _a === void 0 ? void 0 : _a.decode(this.querydecoder),
        });
    }
}
//# sourceMappingURL=PaginatedResponse.js.map